import React from 'react';
import { Typography } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
    root: {},
    givingInstructionsTitle: {
        fontWeight: typography.fontWeightBold,
    },
    givingMethodTitle: {
        marginTop: spacing(2),
        fontWeight: typography.fontWeightBold,
    },
    givingMethodBullettedList: {
        margin: [[0, 0, 0, spacing(2)]],
    },
    emphasizedInstructions: {
        fontWeight: typography.fontWeightBold,
        textTransform: 'uppercase',
    },
    contact: {
        color: palette.grey[400],
        marginTop: spacing(2),
        textAlign: 'center',
    },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function VancouverEnglishGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_vancouver`,
        classes.root,
    );

    const givingMethodTitleClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_title`,
        classes.givingMethodTitle,
    );

    const givingMethodBullettedListClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_bulleted_list`,
        classes.givingMethodBullettedList,
    );

    const emphasizedInstructionsClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--instructions-emphasized`,
        classes.emphasizedInstructions,
    );

    return (
        <div className={rootClassNames}>
            <Typography
                // eslint-disable-next-line max-len
                className={ClassNames(classes.givingInstructionsTitle, `${BEM_BLOCK_NAME}--giving_instructions_title`)}
                component="div"
                variant="body1"
            >
                Ways to Give
            </Typography>

            <div className={givingMethodTitleClassNames}>E-Transfer</div>
            <ul className={givingMethodBullettedListClassNames}>
                {/* eslint-disable max-len */}
                <li>
                    Please e-transfer tithe to
                    {'\u00a0'}
                    <a href="mailto:VANCOUVER@SADDLEBACKCA.COM">VANCOUVER@SADDLEBACKCA.COM</a>
                    {'\u00a0'}
                    from your financial institution.
                </li>
                <li>
                    Remarks:
                    {'\u00a0'}
                    <span className={emphasizedInstructionsClassNames}>{`PLEASE PUT YOUR INFO IN THE REMARKS IN WRITTEN ‘${campaignName}’ AND FULL NAME, PHONE NUMBER, EMAIL ADDRESS`}</span>
                </li>
                {/* eslint-enable max-len */}
            </ul>

            <div className={givingMethodTitleClassNames}>Cheque/Cash</div>
            <ul className={givingMethodBullettedListClassNames}>
                {/* eslint-disable max-len */}
                <li>
                    Make Payable To:
                    {'\u00a0'}
                    <span className={emphasizedInstructionsClassNames}>SADDLEBACK CHURCH HONG KONG (VANCOUVER)</span>
                </li>
                <li>
                    Tithe Envelope:
                    {'\u00a0'}
                    <span className={emphasizedInstructionsClassNames}>{`PLEASE PUT YOUR INFO IN THE REMARKS IN WRITTEN ‘${campaignName}’ AND FULL NAME, PHONE NUMBER, EMAIL ADDRESS`}</span>
                </li>
                {/* eslint-disable max-len */}
            </ul>

            <div className={ClassNames(`${BEM_BLOCK_NAME}--giving_instructions_vancouver_contact`, classes.contact)}>
                {`For any inquiries about ‘${campaignName}’ tithe, please email`}
                {'\u00a0'}
                <a href="mailto:accounting@saddlebackca.com">accounting@saddlebackca.com</a>
            </div>
        </div>
    );
}

export default VancouverEnglishGivingInstructions;
